<template>
  <v-text-field
    outline
    class="py-2"
    :append-icon="shouldClearFilter ? 'mdi-close' : 'mdi-magnify'"
    :hide-details="true"
    @click:append="shouldClearFilter ? clearFilter() : emitChange()"
    @keyup.enter="emitChange"
    @input="handleInput"
    :value="inputText"
    :label="label"
  ></v-text-field>
</template>

<script>
export default {
  props: ['value', 'label'],
  data() {
    return {
      inputText: '',
      lastSearchText: ''
    };
  },
  methods: {
    handleInput(event) {
      this.inputText = event;
    },
    clearFilter() {
      this.inputText = '';
      this.emitChange();
    },
    emitChange() {
      this.lastSearchText = this.inputText;
      this.$emit('input', this.inputText);
    }
  },
  computed: {
    shouldClearFilter() {
      return this.lastSearchText && this.lastSearchText === this.inputText;
    }
  },
  watch: {
    value() {
      this.inputText = this.value;
      this.lastSearchText = this.value;
    },
  }
};

</script>
